import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useRef, useState } from "react";
import ResultCard from "./ResultCard";
import { IStudentRegister } from "../types";
// import { useQueryHook } from "../hooks/react-query/useQueryHook";
import Button from "./Button";
import { FaPrint } from "react-icons/fa";
import { useReactToPrint } from "react-to-print";

/**
 * 
 */
export default function ResultModal({ show, user, hideModal }: { show: boolean, user: IStudentRegister, hideModal: () => void }) {
    const printRef = useRef(null);
    const [isOpen, setIsOpen] = useState(show);
    
    const handlePrint = useReactToPrint({
        content: () => {
            return printRef.current;
        }
    });

    useEffect(() => {
        setIsOpen(show);
    }, [show]);

    const handlePrintClick = () => handlePrint();

    const handleOnClose = () => {
        hideModal();
        setIsOpen(false);
    }

    return (
        <Transition appear show={isOpen} as={Fragment}>

            <Dialog as="div" className="relative z-10" onClose={handleOnClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-fit transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                <ResultCard
                                    printRef={printRef}
                                    user={user}
                                />

                                <div className="text-center mt-6">
                                    <Button
                                        icon={<FaPrint />}
                                        label="Print"
                                        onClick={handlePrintClick}
                                    />
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}